// extracted by mini-css-extract-plugin
export default {"fullWidthDivider":"hoardForm_fullWidthDivider__V14Nj"};